export default __webpack_public_path__ + "df3f2b1bf6b7462148391c2ce7a65747.png";